import { createContext } from 'react';
import { SearchParams } from '../components/CustomerSearchBox/CustomerSearchBox';
import { CustomerBySearchType, CustomersBySearchResponse } from '../data/types';

export interface CustomerSearchContext {
  searchParams: SearchParams;
  setSearchParams: (searchParams: SearchParams) => void;
  onAddCustomer?: () => void;
  loading: boolean;
  error: string;
  results: CustomerBySearchType[] | null;
  failedTenants: string[] | null;
  setFailedTenants: (tenants: string[] | null) => void;
  setResults: (results: CustomerBySearchType[] | null) => void;
  firstLoad: boolean;
  selectedCustomer: SelectCustomerType | undefined;
  search: (
    params: SearchParams,
  ) => Promise<CustomersBySearchResponse | undefined>;
  onSelectCustomer: (customer?: Partial<CustomerBySearchType>) => void;
}

export type SelectCustomerType = Pick<
  CustomerBySearchType,
  'id' | 'name' | 'tenant'
>;

const AddressFormManagerContext = createContext<
  CustomerSearchContext | undefined
>(undefined);

export default AddressFormManagerContext;
